<template>
    <div class="AppStoreBadges">
        <a :href="appleLink" target="_blank">
            <img src="/img/apple-store-badge.svg" alt="Apple Store">
        </a>
        <a :href="googleLink" target="_blank">
            <img src="/img/google-play-badge.svg" alt="Google Play Store">
        </a>
    </div>
</template>

<script>
export default {
    name: 'AppStoreBadges',

    data: () => ({
        appleLink: 'https://apps.apple.com/us/app/dumptek/id1489227344',
        googleLink: 'https://play.google.com/store/apps/details?id=com.dumptek&hl=en_US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
    }),
};
</script>

<style lang="scss" scoped>
@use 'sass:math';
@import 'globals.scss';

.AppStoreBadges {
    display: flex;
    justify-content: center;

    img {
        height: 60px;
        margin: math.div($grid-gutter-width, 2);
    }

    @include breakpoint(xs) {
        flex-direction: column;
    }
}
</style>
